var _defs, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtn20382038(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 313.53 150.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-3, .cls-5, .cls-8, .cls-10, .cls-13, .cls-20 {\n        isolation: isolate;\n      }\n\n      .cls-3, .cls-13, .cls-20 {\n        opacity: .5;\n      }\n\n      .cls-28 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#radial-gradient-9);\n      }\n\n      .cls-5, .cls-8, .cls-10 {\n        opacity: .3;\n      }\n\n      .cls-29 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-8 {\n        fill: url(#radial-gradient-13);\n      }\n\n      .cls-9 {\n        fill: #6171e5;\n      }\n\n      .cls-10 {\n        fill: url(#radial-gradient-4);\n      }\n\n      .cls-11 {\n        fill: url(#radial-gradient-6);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-30 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-15 {\n        fill: url(#radial-gradient-11);\n      }\n\n      .cls-16 {\n        fill: url(#radial-gradient-8);\n      }\n\n      .cls-17 {\n        fill: #e57361;\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-31 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-21 {\n        fill: url(#radial-gradient-7);\n      }\n\n      .cls-32 {\n        fill: none;\n      }\n\n      .cls-22 {\n        fill: url(#radial-gradient-3);\n      }\n\n      .cls-23 {\n        fill: url(#radial-gradient-10);\n      }\n\n      .cls-24 {\n        fill: url(#radial-gradient-12);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-26 {\n        fill: url(#radial-gradient-5);\n      }\n\n      .cls-27 {\n        fill: #c5dfff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 484.34,
    y: 0,
    width: 157.24,
    height: 150.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 550.94,
    y1: -418.8,
    x2: 243.32,
    y2: -111.17,
    gradientTransform: "translate(0 -190.2) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#001e8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 543.05,
    y1: -410.9,
    x2: 251.22,
    y2: -119.07,
    gradientTransform: "translate(0 -190.2) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0933ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b51e3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 188.23,
    cy: -185.04,
    fx: 188.23,
    fy: -185.04,
    r: 449.57,
    gradientTransform: "translate(0 -190.2) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0019b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010d01"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 189.42,
    cy: -321.93,
    fx: 189.42,
    fy: -321.93,
    r: 463.13,
    gradientTransform: "translate(0 -190.2) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005ad6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 197.48,
    cy: -187.5,
    fx: 197.48,
    fy: -187.5,
    r: 379.04,
    gradientTransform: "translate(0 -190.2) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0019b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010d01"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: -213.99,
    cy: -312.44,
    fx: -213.99,
    fy: -312.44,
    r: 68.84,
    gradientTransform: "translate(1298.65 -190.2) scale(4.21 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0019b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010d01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 164.41,
    y1: -257.69,
    x2: 630.33,
    y2: -257.69,
    gradientTransform: "translate(0 -190.2) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0019b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010d01"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    y: 0,
    width: 157.24,
    height: 150.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 398.26,
    y1: -418.8,
    x2: 90.64,
    y2: -111.17,
    gradientTransform: "translate(0 -190.2) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a0a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d40500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 390.36,
    y1: -410.9,
    x2: 98.53,
    y2: -119.07,
    gradientTransform: "translate(0 -190.2) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ba1309"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e30f0b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 35.54,
    cy: -185.04,
    fx: 35.54,
    fy: -185.04,
    r: 449.57,
    gradientTransform: "translate(0 -190.2) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b01e09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010d01"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 36.73,
    cy: -321.93,
    fx: 36.73,
    fy: -321.93,
    r: 463.13,
    gradientTransform: "translate(0 -190.2) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6000a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: -16.53,
    cy: -199.77,
    fx: -16.53,
    fy: -199.77,
    r: 170.43,
    gradientTransform: "translate(0 -190.2) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b01e09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010d01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 7.04,
    y1: -285.11,
    x2: 7.04,
    y2: -196.17,
    gradientTransform: "translate(0 -190.2) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010d01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b01e09"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 44.8,
    cy: -187.5,
    fx: 44.8,
    fy: -187.5,
    r: 379.04,
    gradientTransform: "translate(0 -190.2) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b01e09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010d01"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: -250.29,
    cy: -312.44,
    fx: -250.29,
    fy: -312.44,
    r: 68.84,
    gradientTransform: "translate(1298.65 -190.2) scale(4.21 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b01e09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010d01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 11.73,
    y1: -241.34,
    x2: 477.65,
    y2: -241.34,
    gradientTransform: "translate(0 -190.2) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b01e09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010d01"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 156.3,
    y: 0,
    width: 157.24,
    height: 150.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 222.9,
    y1: -418.8,
    x2: -84.72,
    y2: -111.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 215,
    y1: -410.9,
    x2: -76.83,
    y2: -119.07,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: -139.82,
    fx: -139.82,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: -138.63,
    fx: -138.63,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 300,
    y1: -264.98,
    x2: 312.98,
    y2: -264.98,
    gradientTransform: "translate(0 -190.2) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005ad6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: -130.56,
    fx: -130.56,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: -291.97,
    fx: -291.97,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -163.64,
    x2: 302.29,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m170.56.89h453.15c9.56.02,17.3,7.76,17.32,17.32v113.16c-.02,9.56-7.76,17.3-17.32,17.32H170.56c-9.56-.02-17.3-7.76-17.32-17.32V18.2c0-4.59,1.83-8.99,5.08-12.23,3.24-3.25,7.64-5.08,12.23-5.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m170.56,12.06c-1.63,0-3.19.65-4.34,1.81-1.16,1.15-1.81,2.71-1.81,4.34v113.16c.02,3.39,2.76,6.13,6.14,6.14h453.15c3.39-.02,6.13-2.76,6.14-6.14V18.2c-.02-3.39-2.76-6.13-6.14-6.14H170.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m170.56,12.06h453.15c1.63,0,3.19.65,4.34,1.81l7.9-7.9c-3.24-3.25-7.64-5.08-12.23-5.08H170.56c-4.59,0-8.99,1.83-12.23,5.08l7.9,7.9c1.15-1.16,2.71-1.81,4.34-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m623.71,137.5H170.56c-1.63,0-3.19-.65-4.34-1.81l-7.9,7.9c3.24,3.25,7.64,5.08,12.23,5.08h453.15c4.59,0,8.99-1.83,12.23-5.08l-7.9-7.9c-1.15,1.16-2.71,1.81-4.34,1.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m623.71,2.56H170.56c-4.15,0-8.12,1.65-11.05,4.59-2.94,2.93-4.59,6.9-4.59,11.05v72.3c0,5.14,7.82,5.14,7.82,0V18.2c0-2.07.83-4.06,2.3-5.52,1.46-1.47,3.45-2.3,5.52-2.3h453.15c4.31.02,7.8,3.51,7.82,7.82v16.9c0,5.14,7.82,5.14,7.82,0v-16.9c-.02-8.63-7.01-15.62-15.64-15.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m325.63,8.85c-84.23,0-152.51,1.02-152.51,1.54s125.76.47,152.51.47,152.51.05,152.51-.47-68.28-1.54-152.51-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m397.37,143.1c-125.52,0-227.27-2.16-227.27-3.25s187.4-.98,227.27-.98,227.27-.11,227.27.98c0,.81-56.41,2.03-136.97,2.7-27.69.23-58.18.55-90.29.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m164.41,122.92c40.91-7.84,198.9-30.68,321.95-49.96,65.65-10.29,121.59-20.44,143.97-24.84v-27.34c0-4.78-2.77-8.71-6.14-8.71H170.56c-1.78.09-3.4,1.05-4.34,2.56-1.21,1.82-1.84,3.96-1.81,6.15v102.14Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.87.89h453.15c9.56.02,17.3,7.76,17.32,17.32v113.16c-.02,9.56-7.76,17.3-17.32,17.32H17.87c-9.56-.02-17.3-7.76-17.32-17.32V18.2C.57,8.65,8.31.91,17.87.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m17.87,12.06c-3.39.02-6.13,2.76-6.14,6.14v113.16c.02,3.39,2.76,6.13,6.14,6.14h453.15c3.39-.02,6.13-2.76,6.14-6.14V18.2c-.02-3.39-2.76-6.13-6.14-6.14H17.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m17.87,12.06h453.15c1.63,0,3.19.65,4.34,1.81l7.9-7.9c-3.24-3.25-7.64-5.08-12.23-5.08H17.87c-4.59,0-8.99,1.83-12.23,5.08l7.9,7.9c1.15-1.15,2.71-1.81,4.34-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m471.02,137.5H17.87c-1.63,0-3.19-.65-4.34-1.81l-7.9,7.9c3.24,3.25,7.64,5.08,12.23,5.08h453.15c4.59,0,8.99-1.83,12.23-5.08l-7.9-7.9c-1.15,1.15-2.71,1.81-4.34,1.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m11.73,131.36V18.2c0-1.63.65-3.19,1.81-4.34l-7.9-7.9C2.38,9.21.55,13.61.56,18.2v113.16c0,4.59,1.83,8.99,5.08,12.23l7.9-7.9c-1.15-1.15-1.81-2.71-1.81-4.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m11.73,90.22V18.2c0-1.63.65-3.19,1.81-4.34l-7.9-7.9C2.38,9.21.55,13.61.56,18.2v76.71c1.97-1.92,8.19-4.44,11.17-4.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m471.02,2.56H17.87c-8.63.02-15.62,7.01-15.64,15.64v72.3c0,5.14,7.82,5.14,7.82,0V18.2c.02-4.31,3.51-7.8,7.82-7.82h453.15c4.31.02,7.8,3.51,7.82,7.82v16.9c0,5.14,7.82,5.14,7.82,0v-16.9c-.02-8.63-7.01-15.62-15.64-15.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m8.24,142.3c1.16-1.72,2.59-3.23,4.25-4.47.86-.54,1.85-.84,2.87-.86-1.73-.79-3.01-2.32-3.46-4.16.2,1.33-.03,2.68-.67,3.86-1.16,1.72-2.59,3.23-4.25,4.47-.87.57-1.93.79-2.96.6,1.07,1.42,2.35,2.67,3.8,3.71-.28-1.06-.13-2.2.42-3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m8.24,7.27c1.16,1.72,2.59,3.23,4.25,4.47.86.54,1.85.84,2.87.87-1.73.78-3.01,2.32-3.46,4.16.2-1.33-.03-2.68-.67-3.86-1.16-1.72-2.59-3.23-4.25-4.47-.87-.57-1.93-.79-2.96-.6,1.07-1.42,2.35-2.67,3.8-3.71-.28,1.06-.13,2.19.42,3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m244.69,143.1c-125.52,0-227.27-2.16-227.27-3.25s187.4-.98,227.27-.98,227.27-.11,227.27.98-101.75,3.25-227.27,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m11.73,90.22c62.74-8.48,401.58-43.82,465.92-52.74v-19.28c-.02-3.39-2.76-6.13-6.14-6.14H17.87c-3.39.02-6.13,2.76-6.14,6.14v72.01Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m-157.49.89h453.15c9.56.02,17.3,7.76,17.32,17.32v113.16c-.02,9.56-7.76,17.3-17.32,17.32H-157.49c-9.56-.02-17.3-7.76-17.32-17.32V18.2c0-4.59,1.83-8.99,5.08-12.23,3.24-3.25,7.64-5.08,12.23-5.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m-157.49,12.06c-1.63,0-3.19.65-4.34,1.81-1.16,1.15-1.81,2.71-1.81,4.34v113.16c.02,3.39,2.76,6.13,6.14,6.14h453.15c3.39-.02,6.13-2.76,6.14-6.14V18.2c-.02-3.39-2.76-6.13-6.14-6.14H-157.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m-157.49,12.06h453.15c1.63,0,3.19.65,4.34,1.81l7.9-7.9c-3.24-3.25-7.64-5.08-12.23-5.08H-157.49c-4.59,0-8.99,1.83-12.23,5.08l7.9,7.9c1.15-1.16,2.71-1.81,4.34-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m295.66,137.5H-157.49c-1.63,0-3.19-.65-4.34-1.81l-7.9,7.9c3.24,3.25,7.64,5.08,12.23,5.08h453.15c4.59,0,8.99-1.83,12.23-5.08l-7.9-7.9c-1.15,1.16-2.71,1.81-4.34,1.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m301.81,18.2v113.16c0,1.63-.65,3.19-1.81,4.34l7.9,7.9c3.25-3.24,5.08-7.64,5.08-12.23V18.2c0-4.59-1.83-8.99-5.08-12.23l-7.9,7.9c1.15,1.15,1.81,2.71,1.81,4.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m295.66,2.56H-157.49c-4.15,0-8.12,1.65-11.05,4.59-2.94,2.93-4.59,6.9-4.59,11.05v72.3c0,5.14,7.82,5.14,7.82,0V18.2c0-2.07.83-4.06,2.3-5.52,1.46-1.47,3.45-2.3,5.52-2.3h453.15c4.31.02,7.8,3.51,7.82,7.82v16.9c0,5.14,7.82,5.14,7.82,0v-16.9c-.02-8.63-7.01-15.62-15.64-15.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m-2.42,8.85c-84.23,0-152.51,1.02-152.51,1.54s125.76.47,152.51.47,152.51.05,152.51-.47-68.28-1.54-152.51-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m305.29,142.3c-1.16-1.72-2.59-3.23-4.25-4.47-.86-.54-1.85-.84-2.87-.86,1.73-.78,3.01-2.32,3.46-4.16-.2,1.33.03,2.68.67,3.86,1.16,1.72,2.59,3.23,4.25,4.47.87.57,1.93.79,2.96.6-1.07,1.42-2.35,2.67-3.8,3.71.28-1.06.13-2.2-.42-3.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m305.29,7.27c-1.16,1.72-2.59,3.23-4.25,4.47-.86.54-1.85.84-2.87.86,1.73.79,3.01,2.32,3.46,4.16-.2-1.33.03-2.68.67-3.86,1.16-1.72,2.59-3.23,4.25-4.47.87-.57,1.93-.79,2.96-.6-1.07-1.42-2.35-2.67-3.8-3.71.28,1.06.13,2.2-.42,3.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m69.33,143.1c-125.52,0-227.27-2.16-227.27-3.25s187.4-.98,227.27-.98,227.27-.11,227.27.98c0,.81-56.41,2.03-136.97,2.7-27.69.23-58.18.55-90.29.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m-163.63,122.92c40.91-7.84,198.9-30.68,321.95-49.96,65.65-10.29,121.59-20.44,143.97-24.84v-27.34c0-4.78-2.77-8.71-6.14-8.71H-157.49c-1.78.09-3.4,1.05-4.34,2.56-1.21,1.82-1.84,3.96-1.81,6.15v102.14Z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m23.69,85.24c2.94-2.43,5.26-4.42,6.95-5.99,1.69-1.56,3.13-3.19,4.3-4.9s1.75-3.38,1.75-5c0-1.23-.29-2.19-.85-2.88-.57-.69-1.42-1.04-2.56-1.04s-2.03.43-2.68,1.28c-.65.86-.97,2.06-.97,3.62h-7.42c.06-2.55.61-4.68,1.64-6.39,1.03-1.71,2.4-2.97,4.09-3.78,1.69-.81,3.58-1.21,5.65-1.21,3.57,0,6.26.92,8.08,2.74,1.81,1.83,2.72,4.22,2.72,7.16,0,3.21-1.1,6.19-3.29,8.93-2.19,2.75-4.98,5.42-8.37,8.03h12.15v6.25h-22.59v-5.71c1.02-.81,1.49-1.18,1.4-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m49.95,63.46c1.99-2.97,5.21-4.46,9.65-4.46s7.66,1.48,9.65,4.46c2,2.97,2.99,7.04,2.99,12.19s-1,9.32-2.99,12.29-5.21,4.46-9.65,4.46-7.66-1.49-9.65-4.46c-2-2.97-2.99-7.07-2.99-12.29s1-9.22,2.99-12.19Zm13.75,5.2c-.66-1.63-2.02-2.45-4.1-2.45s-3.44.82-4.09,2.45c-.66,1.64-.99,3.97-.99,7,0,2.04.12,3.73.36,5.06.24,1.33.73,2.42,1.46,3.24.73.83,1.82,1.24,3.26,1.24s2.53-.41,3.26-1.24c.73-.83,1.22-1.91,1.46-3.24.24-1.33.36-3.02.36-5.06,0-3.03-.33-5.36-.99-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m95.11,73.54v6.39h-19.8v-6.39h19.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m103.21,61.53c1.98-1.74,4.66-2.61,8.06-2.61,2.25,0,4.18.39,5.78,1.17,1.6.78,2.82,1.84,3.65,3.19.82,1.35,1.24,2.87,1.24,4.54,0,1.98-.5,3.59-1.48,4.84-.99,1.25-2.15,2.09-3.47,2.54v.18c1.71.57,3.06,1.51,4.05,2.83.99,1.32,1.48,3.01,1.48,5.08,0,1.86-.43,3.5-1.28,4.93-.85,1.43-2.1,2.54-3.73,3.35-1.64.81-3.58,1.21-5.83,1.21-3.6,0-6.47-.88-8.62-2.65-2.15-1.77-3.28-4.44-3.4-8.01h7.47c.03,1.32.41,2.36,1.12,3.13.72.76,1.77,1.15,3.15,1.15,1.17,0,2.08-.34,2.72-1.01.65-.67.97-1.57.97-2.68,0-1.44-.46-2.48-1.37-3.13-.92-.64-2.38-.97-4.39-.97h-1.44v-6.25h1.44c1.53,0,2.77-.26,3.71-.79.95-.52,1.42-1.46,1.42-2.81,0-1.08-.3-1.92-.9-2.52s-1.43-.9-2.48-.9c-1.14,0-1.99.34-2.54,1.04-.56.69-.88,1.54-.97,2.56h-7.52c.12-3.21,1.17-5.68,3.15-7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m126.88,67.83c0-1.62.42-3.1,1.26-4.43.84-1.33,2.11-2.4,3.82-3.19,1.71-.79,3.81-1.19,6.3-1.19s4.58.4,6.28,1.19,2.96,1.86,3.8,3.19c.84,1.34,1.26,2.81,1.26,4.43s-.38,3.03-1.15,4.23c-.77,1.2-1.79,2.15-3.08,2.83,1.62.78,2.86,1.85,3.73,3.22.87,1.37,1.3,2.96,1.3,4.79,0,2.13-.54,3.97-1.62,5.51s-2.54,2.72-4.39,3.53c-1.84.81-3.89,1.21-6.14,1.21s-4.3-.41-6.14-1.21-3.31-1.99-4.39-3.53c-1.08-1.54-1.62-3.38-1.62-5.51,0-1.86.43-3.47,1.3-4.84.87-1.36,2.1-2.42,3.69-3.17-2.82-1.5-4.23-3.85-4.23-7.07Zm7.97,11.54c-.87.76-1.31,1.82-1.31,3.17,0,1.26.43,2.29,1.28,3.11.85.81,2,1.21,3.44,1.21s2.57-.41,3.4-1.21c.82-.81,1.24-1.85,1.24-3.11s-.43-2.37-1.28-3.15c-.86-.78-1.97-1.17-3.35-1.17s-2.55.38-3.42,1.15Zm6.23-13.23c-.71-.67-1.64-1.01-2.81-1.01s-2.11.34-2.81,1.03c-.7.69-1.06,1.65-1.06,2.88s.36,2.09,1.08,2.77c.72.68,1.65,1.01,2.79,1.01s2.07-.34,2.79-1.04c.72-.69,1.08-1.62,1.08-2.79,0-1.23-.35-2.18-1.06-2.86Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m167.7,82.99c2.94-2.43,5.26-4.42,6.95-5.99,1.69-1.56,3.13-3.2,4.3-4.91s1.75-3.38,1.75-4.99c0-1.23-.29-2.19-.86-2.88-.57-.69-1.42-1.03-2.56-1.03s-2.03.43-2.68,1.28c-.65.85-.97,2.06-.97,3.62h-7.42c.06-2.55.61-4.68,1.64-6.39s2.4-2.97,4.09-3.78c1.7-.81,3.58-1.21,5.65-1.21,3.57,0,6.26.92,8.08,2.75,1.81,1.83,2.72,4.21,2.72,7.16,0,3.21-1.1,6.19-3.29,8.93-2.19,2.75-4.98,5.42-8.37,8.03h12.15v6.25h-22.59v-5.71c1.02-.81,1.49-1.18,1.4-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m193.96,61.21c1.99-2.97,5.21-4.46,9.65-4.46s7.66,1.49,9.65,4.46,2.99,7.04,2.99,12.2-1,9.32-2.99,12.29-5.21,4.46-9.65,4.46-7.66-1.49-9.65-4.46c-2-2.97-2.99-7.07-2.99-12.29s1-9.23,2.99-12.2Zm13.75,5.2c-.66-1.63-2.02-2.45-4.09-2.45s-3.44.82-4.09,2.45c-.66,1.64-.99,3.97-.99,7,0,2.04.12,3.73.36,5.06s.73,2.42,1.46,3.24c.73.83,1.82,1.24,3.26,1.24s2.53-.41,3.26-1.24c.73-.83,1.22-1.91,1.46-3.24s.36-3.02.36-5.06c0-3.03-.33-5.36-.99-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m239.11,71.29v6.39h-19.8v-6.39h19.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m247.21,59.28c1.98-1.74,4.67-2.61,8.06-2.61,2.25,0,4.18.39,5.78,1.17,1.6.78,2.82,1.84,3.65,3.2.82,1.35,1.24,2.87,1.24,4.54,0,1.98-.5,3.59-1.49,4.84-.99,1.25-2.15,2.09-3.46,2.54v.18c1.71.57,3.06,1.52,4.05,2.84s1.49,3.01,1.49,5.08c0,1.86-.43,3.5-1.28,4.93-.85,1.43-2.1,2.54-3.73,3.35-1.64.81-3.58,1.21-5.83,1.21-3.6,0-6.47-.88-8.62-2.65-2.15-1.77-3.28-4.44-3.4-8.01h7.47c.03,1.32.41,2.36,1.12,3.13.72.76,1.77,1.15,3.15,1.15,1.17,0,2.08-.34,2.72-1.01.64-.67.97-1.57.97-2.68,0-1.44-.46-2.48-1.37-3.13-.92-.64-2.38-.97-4.39-.97h-1.44v-6.25h1.44c1.53,0,2.77-.26,3.71-.79.95-.53,1.42-1.46,1.42-2.81,0-1.08-.3-1.92-.9-2.52-.6-.6-1.43-.9-2.48-.9-1.14,0-1.99.35-2.54,1.04-.56.69-.88,1.55-.97,2.57h-7.51c.12-3.21,1.17-5.68,3.15-7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m270.88,65.58c0-1.62.42-3.1,1.26-4.43s2.12-2.4,3.83-3.2c1.71-.79,3.81-1.19,6.3-1.19s4.58.4,6.28,1.19c1.7.8,2.96,1.86,3.8,3.2s1.26,2.81,1.26,4.43-.38,3.03-1.15,4.23c-.77,1.2-1.79,2.15-3.08,2.83,1.62.78,2.86,1.85,3.73,3.22.87,1.37,1.3,2.96,1.3,4.79,0,2.13-.54,3.97-1.62,5.51s-2.54,2.72-4.39,3.53c-1.84.81-3.89,1.21-6.14,1.21s-4.3-.41-6.14-1.21c-1.84-.81-3.31-1.99-4.39-3.53-1.08-1.54-1.62-3.38-1.62-5.51,0-1.86.43-3.47,1.3-4.84.87-1.36,2.1-2.42,3.69-3.17-2.82-1.5-4.23-3.85-4.23-7.06Zm7.96,11.54c-.87.76-1.3,1.82-1.3,3.17,0,1.26.43,2.29,1.28,3.11.86.81,2,1.21,3.44,1.21s2.57-.41,3.4-1.21c.82-.81,1.24-1.85,1.24-3.11s-.43-2.37-1.28-3.15c-.86-.78-1.97-1.17-3.35-1.17s-2.55.38-3.42,1.15Zm6.23-13.23c-.71-.67-1.64-1.01-2.81-1.01s-2.11.35-2.81,1.04c-.71.69-1.06,1.65-1.06,2.88s.36,2.09,1.08,2.77c.72.67,1.65,1.01,2.79,1.01s2.07-.34,2.79-1.04c.72-.69,1.08-1.62,1.08-2.79,0-1.23-.35-2.18-1.06-2.86Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtn20382038);
export default __webpack_public_path__ + "static/media/btn_20_38_20-38.0feba9b8fc63307e4105988fc03de2a5.svg";
export { ForwardRef as ReactComponent };